import { lazy } from "react";

const PUBLIC_ROUTES = [
  {
    key: "page.grant",
    path: "/programs/:id",
    component: lazy(() => import("@/pages/GrantDetailsPage")),
    meta: { index: true },
  },
  {
    key: "page.dashboard",
    path: "/",
    component: lazy(() => import("@/pages/DashboardPage")),
    meta: { index: true },
  },
  {
    key: "page.invite",
    path: "/invite/:code",
    component: lazy(() => import("@/pages/InvitePage")),
    meta: { index: true },
  },
  {
    key: "page.leaderboard",
    path: "/leaderboard",
    component: lazy(() => import("@/pages/LeaderboardPage")),
    meta: { index: true },
  },
  {
    key: "page.pre-season-leaderboard",
    path: "/pre-season-leaderboard",
    component: lazy(() => import("@/pages/PreSeasonLeaderboardPage")),
    meta: { index: true },
  },
] as const;

export type PublicRouteKey = (typeof PUBLIC_ROUTES)[number]["key"];

export default PUBLIC_ROUTES;
